import React from 'react';
export function ProblemSection() {
  return <section className="bg-brand-grayLight py-8 px-5" data-id="element-224">
      <div className="max-w-4xl mx-auto" data-id="element-225">
        <div className="p-0" data-id="element-226">
          <h2 className="text-2xl md:text-3xl font-black text-slate-900 mb-8 leading-tight text-center" data-id="element-227">
            😩 ¿TE PASA ESTO EN TU DÍA A DÍA? <br data-id="element-228" />
            <span className="text-red-500 text-lg md:text-xl block mt-2" data-id="element-229">
              Te levantás sabiendo que te espera otro día resolviendo mil cosas
              a la vez.
            </span>
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mb-12" data-id="element-230">
            {['Respondés consultas según cómo venga cada conversación', 'Algunas clientas te drenan energía porque todo depende de cómo expliques o resuelvas en el momento', 'Dudás cuánto cobrar o cómo justificar presupuestos sin incomodidad', 'Tu agenda, organización o flujo diario se vuelven caóticos', 'Sentís que apagás incendios todo el tiempo', 'Te cuesta sostener procesos claros porque todo cambia según el caso', 'Aunque técnicamente trabajás bien, a veces sentís desorden interno', 'Terminás agotada porque TODO depende de vos', 'Querés trabajar como una profesional más estructurada… pero seguís improvisando demasiadas cosas'].map((problem, idx) => <div key={idx} className="bg-white border border-slate-200 p-5 rounded-2xl flex items-start gap-4 transition-all hover:shadow-lg" data-id="element-231">
                <span className="text-red-500 text-lg flex-shrink-0" data-id="element-232">❌</span>
                <p className="text-sm text-slate-600 font-medium leading-relaxed" data-id="element-233">
                  {problem}
                </p>
              </div>)}
          </div>

          <div className="text-center mb-8 max-w-2xl mx-auto" data-id="element-234">
            <h3 className="text-xl md:text-2xl font-bold mb-4 text-slate-900" data-id="element-235">
              ¿CUÁNTO TIEMPO MÁS VAS A SEGUIR SOSTENIENDO UN NEGOCIO O TRABAJO
              QUE DEPENDE DE IMPROVISAR TODO?
            </h3>
            <p className="text-slate-500 font-medium italic" data-id="element-236">
              Porque muchas veces el agotamiento NO viene del trabajo en sí.
              Viene de no tener estructura.
            </p>
          </div>

          <div className="bg-white border-2 border-brand-primary/20 p-8 rounded-3xl mt-8 shadow-sm" data-id="element-237">
            <p className="font-black text-xl mb-8 text-center uppercase tracking-tight text-[#D4BD8B]" data-id="element-238">
              ESTO ES LO QUE CAMBIA CUANDO EMPEZÁS A TRABAJAR CON EL SISTEMA
              PELUQUERÍA LISTA™:
            </p>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-6" data-id="element-239">
              {['Respondés con más seguridad', 'Improvisás muchísimo menos', 'Organizás mejor tu día', 'Reducís caos operativo', 'Mejorás cómo te perciben tus clientas', 'Cobrás con más claridad', 'Tenés procesos más consistentes', 'Ahorrás energía mental', 'Ganás más sensación de control', 'Trabajás con mucho más criterio profesional'].map((item, i) => <div key={i} className="flex items-center gap-4" data-id="element-240">
                  <div className="bg-brand-primary/10 w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0" data-id="element-241">
                    <span className="text-brand-primary font-bold text-lg" data-id="element-242">
                      ✔
                    </span>
                  </div>
                  <p className="text-slate-700 text-sm md:text-base font-bold" data-id="element-243">
                    {item}
                  </p>
                </div>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}